export default function disableAutoCorrect(): void {
  const inputs = document.getElementsByTagName('input');
  for (let i = 0; i < inputs.length; i += 1) {
    inputs[i].setAttribute('spellCheck', 'false');
    inputs[i].setAttribute('spellcheck', 'false');
    inputs[i].setAttribute('autoComplete', 'off');
  }
}
